import React from 'react';
import { styled } from '@mui/material/styles';

const sizeMap = {
    sm: '3',
    md: '42px',
    lg: '48px',
  };

const BlueButtonInWhite = styled('a')(
  ({ size = 'sm' }: { size?: 'sm' | 'md' | 'lg' }) => ({
    width: sizeMap[size],
    height: sizeMap[size],
    position: 'relative',
    padding: '10px 20px',
    borderRadius: '50rem',
    background: 'linear-gradient(25deg,rgba(10, 98, 116, 0.69) 10%,rgba(19, 185, 218, 0.66))',
    color: 'white',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0px 2px 10px rgba(0,0,0,0.4)',
    transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
    
    textDecoration: 'none',
    fontSize: '16px',
    border: 'none',
    cursor: 'pointer',
    zIndex: 1,
    backdropFilter: 'blur(10px)',

    '&:hover': {
      background: 'linear-gradient(25deg,rgba(10, 98, 116, 0.9) 10%,rgba(19, 185, 218, 0.8))',
      boxShadow: '0px -1px 4px rgba(226, 226, 226, 0.44)',
    },

    '&:active': {
      background: 'linear-gradient(25deg,rgba(10, 98, 116, 1) 10%,rgba(19, 185, 218,1))',
      boxShadow: 'inset 4px 4px 5px rgba(0,0,0,0.2)',
    },
  })
);

type BlueButtonProps = {
  href: string;
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  target?: string; // Nueva prop para target
  rel?: string;    // Nueva prop para rel
};

const BlueButtonInWhiteComponent: React.FC<BlueButtonProps> = ({
  href,
  size = 'sm',
  children,
  target = '_self', // Valor por defecto
  rel = '',         // Valor por defecto
}) => {
  return (
    <BlueButtonInWhite 
      href={href} 
      size={size} 
      target={target} 
      rel={rel}
    >
      {children}
    </BlueButtonInWhite>
  );
};

export default BlueButtonInWhiteComponent;